import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { Button } from '@grandvisionhq/common';
import { Container, Heading } from '@grandvisionhq/elements';
import { useProductViewHistory } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import { withLazyLoading, isDefined } from '@grandvisionhq/utils';
import '@swc/helpers';
import '@grandvisionhq/inventory';
import '@grandvisionhq/commercetools';
import { createImpressionEvent, createInteractionEvent } from '../../DataLayer/Events/ProductPromotionEvents.js';
import { mapProductProjectionToListingProduct } from '../../ProductListing/mappers/listing-product/map-product-projection-to-listing-product.js';
import { useGetProductsBySku } from '../../utils/use-get-products-by-sku.js';
import { ProductListingGalleryWrapper } from '../ProductListingGallery/ProductListingGalleryWrapper.js';

const RecentlyViewedProducts = ({ title , renderLocation , reimbursableLogos ,  })=>{
    const intl = useIntl();
    const { currency , getLabel  } = intl;
    const { history , clear  } = useProductViewHistory();
    const { isLoading , products , error  } = useGetProductsBySku(history);
    const noHistory = Array.isArray(history) && history.length === 0;
    const noProducts = !error && (products === null || products === void 0 ? void 0 : products.length) === 0;
    const listingProducts = React.useMemo(()=>{
        return (products === null || products === void 0 ? void 0 : products.length) > 0 ? products.map((product)=>mapProductProjectionToListingProduct(product, intl)
        ).filter(isDefined) : [];
    }, [
        products,
        intl
    ]);
    const handleImpression = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createImpressionEvent(product, position, `recently-viewed recommendation ${renderLocation}`, currency));
    }, [
        currency,
        renderLocation
    ]);
    const handleInteraction = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createInteractionEvent(product, position, `recently-viewed recommendation ${renderLocation}`, currency));
    }, [
        currency,
        renderLocation
    ]);
    // Only return null when we are sure the history is empty or when there are no products matching the SKU's in history,
    // i.e. unpublished products
    // as history will never be defined on the server and can result in HTML mismatches if we always return
    if (noHistory || noProducts) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "recently-viewed-products",
        "data-t": "recently-viewed-products"
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium"
    }, title || getLabel('products.recentlyViewed.title')), /*#__PURE__*/ React.createElement(ProductListingGalleryWrapper, {
        isLoading: isLoading,
        hasError: Boolean(error),
        products: listingProducts,
        onProductImpression: handleImpression,
        onProductInteraction: handleInteraction,
        productLocation: "recentlyViewedProducts",
        reimbursableLogos: reimbursableLogos
    }), /*#__PURE__*/ React.createElement("div", {
        className: "recently-viewed-products__clear"
    }, /*#__PURE__*/ React.createElement(Button, {
        caption: getLabel('products.recentlyViewed.clear'),
        onClick: clear,
        variant: "ghost",
        size: "custom"
    }))));
};
var RecentlyViewedProducts$1 = withLazyLoading(RecentlyViewedProducts, {
    rootMargin: '200px 0px'
});

export { RecentlyViewedProducts, RecentlyViewedProducts$1 as default };
//# sourceMappingURL=RecentlyViewedProducts.js.map
